import { DefaultLayout } from "~/layouts/DefaultLayout";
import { CategoryList } from "~/components/CategoryList";
import { MetaHeader } from "~/components/MetaHeader";
import { AtmosphereImages } from "~/constants";

const Area: React.VFC = () => {
    return (
        <>

            <MetaHeader title={"雰囲気検索 - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"「カテゴリー検索 | 福岡カフェ日記」では、福岡の多様なカフェ文化をカテゴリー別に探索できます。ブックカフェ、古民家カフェ、コーヒースタンドなど、あなたの気分やシーンに合わせたカフェを見つけることができます。読書を楽しみながら静かに過ごせるブックカフェ、歴史を感じることができる美しい古民家カフェ、手軽に本格的なコーヒーを楽しめるコーヒースタンドまで、さまざまなカフェの魅力を紹介します。それぞれのカテゴリーには、特色あるカフェのリストと詳細な情報が用意されているので、新しいお気に入りの場所を見つける旅をお楽しみください。"} />

            <DefaultLayout>
                <h1 className="category_title">カテゴリーから選ぶ</h1>
                <CategoryList categoryList={AtmosphereImages} />
            </DefaultLayout>
        </>
    );
};

export default Area;